export enum ActionType {
  UNKNOWN = 'unknown',
  CHECK_RETAILER = 'Check Retailer',
  INTERNAL = 'internal',
  EXTERNAL = 'external',
  TOGGLE_FILTERS = 'Toggle Filters',
  READ_MORE = 'Read More',
  READ_LESS = 'Read Less',
  RETAILER = 'retailer',
  CC = 'CC',
  ROW_TOGGLE = 'Row Toggle',
  TAB_CHANGED = 'Tab Changed',
  AMAZON_STAR_RATING = 'Amazon Star Rating',
  WALMART_STAR_RATING = 'Walmart Star Rating',
  PHONE_NUMBER = 'Phone Number',
  REVIEW = 'Review',
  SCROLL_TO_PREVIOUS_PAGE = 'Scroll to previous page',
  SCROLL_TO_NEXT_PAGE = 'Scroll to next page',
  SEASONAL_EVENT_RETAILER = 'Seasonal Event Retailer',
  AMAZON_PRIME = 'Amazon Prime',
  SWITCHER = 'Switcher',
  AVAILABLE_FROM = 'Available From',
  DEALS_PAGE = 'Deals Page',
  FILTER = 'Filter',
  INPUT_FIELD = 'input field',
  COPY_CODE = 'copy code',
  GO_TO_RETAILER = 'go to retailer',
  CLEAR_FILTERS = 'Clear filters',
  MODEL_SUGGESTION = 'Model suggestion',
  BACK_TO_PARENT_MODEL_NAVIGATION = 'Back to parent model navigation',
  PAGINATION = 'Pagination',
  USER_INPUT_SUBMITTED = 'User input submitted',
  RADIO_BUTTON_GROUP = 'Radio button group',
  CHECKBOX_GROUP = 'Checkbox group',
  CHECKBOX = 'Checkbox',
  SORT = 'Sort',
  RESET_DEALS = 'Reset deals',
  LOAD_MORE = 'Load more',
  APPEARED = 'appeared',
  SKIPPED = 'skipped',
  MISSING = 'missing',
  PRESERVED = 'preserved',
}

export interface GetActionTypeParams {
  link: string;
  articleUrl: string;
  actionType?: ActionType;
  productType?: number;
}

export type GetActionType = ({
  link,
  articleUrl,
  actionType,
  productType,
}: GetActionTypeParams) => ActionType;
